import axios from "axios";
import { appCheck, firebaseApp } from "config/firebase";
import { getToken } from "firebase/app-check";
import { getAuth } from "firebase/auth";

const baseUrlV1 = process.env.REACT_APP_OUTPUT_HUB_API
  ? `${process.env.REACT_APP_OUTPUT_HUB_API}/api/v1`.replace(/([^:]\/)\/+/g, "/")
  : "/api/v1";

const axiosInstance = axios.create({
  baseURL: baseUrlV1,
});

const requestInterceptor = async (config) => {
  const jwt = await getAuth(firebaseApp).currentUser?.getIdToken();

  config.headers.set("Accept", "application/json");
  config.headers.set("Content-Type", "application/json");

  if (appCheck !== undefined) {
    const appCheckTokenResponse = await getToken(appCheck, /* forceRefresh=false */ false);

    config.headers.set("X-Firebase-AppCheck", appCheckTokenResponse.token);
  }

  if (jwt) config.headers.set("Authorization", `Bearer ${jwt}`);

  return { ...config };
};
const requestInterceptorError = async (error) => Promise.reject(error);

axiosInstance.interceptors.request.use(requestInterceptor, requestInterceptorError);

const http = axiosInstance;

const baseUrlV2 = `${baseUrlV1}`.replace("api/v1", "api/v2");

/**
 * @name apiV2
 * @type {import("axios").AxiosInstance} */
export const apiV2 = http.create({ baseURL: baseUrlV2 });
apiV2.interceptors.request.use(requestInterceptor, requestInterceptorError);

export { http as apiV1 };

// Admin API
const ADMIN_BASE_URL = process.env.REACT_APP_OUTPUT_ADMIN_API
  ? `${process.env.REACT_APP_OUTPUT_ADMIN_API}/api/v1`.replace(/([^:]\/)\/+/g, "/")
  : "/api/v1";

const adminAxiosInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
});

adminAxiosInstance.interceptors.request.use(requestInterceptor, requestInterceptorError);
const adminApi = adminAxiosInstance;
export { adminApi };

// MCP API
const MCP_BASE_URL = process.env.REACT_APP_OUTPUT_MCP_API || "http://localhost:8000";

// Deliberately no interceptor: nothing here should attach X-Firebase-AppCheck, since MCP
// never asked for it. No withCredentials either: /connect/login and /connect/complete
// are proxied same-origin via the Firebase Hosting rewrites in firebase.json, so the
// browser attaches the connect flow's anti-session-fixation cookie automatically —
// withCredentials only matters for genuinely cross-site requests.
const mcpAxiosInstance = axios.create({
  baseURL: MCP_BASE_URL,
});

export { mcpAxiosInstance as mcpApi };

export default http;
